//homepae-header.js is the header for ONLY the homepage. This is due to the fact that the homepage also conatins the social icons on
//the left side of the page on desktop view. In mobile view the social icons are on every page on the top.

import React from 'react';
import { Link } from 'gatsby';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitterSquare,
  faLinkedin,
  faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';
import ScrollAnimation from 'react-animate-on-scroll';
import Logo from './logo';
import HomePageStyle from '../home-page/home-page.module.scss';

// The following import prevents a Font Awesome icon server-side rendering bug,
// where the icons flash from a very large icon down to a properly sized one:
import '@fortawesome/fontawesome-svg-core/styles.css';
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false; /* eslint-disable import/first */

const HomeHeader = () => (
  <Navbar>
    <Navbar.Brand>
      <Link to='/'>
        <Logo />
      </Link>
    </Navbar.Brand>
    <Nav className='ml-auto'>
      <div className={HomePageStyle.navItemDiv}>
        <NavDropdown
          className={HomePageStyle.dropdownToggle}
          title='Website Features'
          id='basic-nav-dropdown'
        >
          <ScrollAnimation
            animateIn='fadeInDown'
            duration={2}
            animateOnce={true}
          >
            <Link className={HomePageStyle.navDropdownLink} to='/essentials'>
              The Essentials
            </Link>
            <Link className={HomePageStyle.navDropdownLink} to='/mobile-first'>
              Mobile First
            </Link>
            <Link className={HomePageStyle.navDropdownLink} to='/engaging-menu'>
              Engaging Menu
            </Link>
            <Link
              className={HomePageStyle.navDropdownLink}
              to='/convenient-booking'
            >
              Convenient Booking
            </Link>
          </ScrollAnimation>
        </NavDropdown>
        <Link className={HomePageStyle.navLink} to='/pricing' id='pricingpage'>
          Pricing
        </Link>
        <Link className={HomePageStyle.navLink} to='/templates'>
          Templates
        </Link>
        <Link className={HomePageStyle.navLink} to='/our-story'>
          Our Story
        </Link>
      </div>
      <div className={HomePageStyle.navSocialDiv}>
        <Nav.Link
          href='https://www.linkedin.com/company/first-string-digital/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon
            icon={faLinkedin}
            className={HomePageStyle.navIcon}
          />
        </Nav.Link>
        <Nav.Link
          href='https://www.twitter.com/weareFSDigital'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon
            icon={faTwitterSquare}
            className={HomePageStyle.navIcon}
          />
        </Nav.Link>
        <Nav.Link
          href='https://www.youtube.com/channel/UCIuR10cXn6xTdCQhDgN-cIA'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon
            icon={faYoutubeSquare}
            className={HomePageStyle.navIcon}
          />
        </Nav.Link>
      </div>
    </Nav>
  </Navbar>
);

export default HomeHeader;
